export const getOrderQuantityValues = (
  minQuantity: number = 0,
  maxQuantity: number = 0
) =>
  Array.from({ length: maxQuantity - minQuantity + 1 }, (_, k) => {
    const number = k + minQuantity

    return {
      value: `${number}`,
      text: `${number}`
    }
  })
